/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addUserData } from '../../redux/reducers/UserRolesReducer'
import { APP_TYPE, USER_ACTION } from '../../utils/constants/UIConstants'
import {
  ApplicationTypes,
  ApplicationTypesData,
  appSelectedTypesData,
  RoleInfoData,
} from '../../interface/response/UserRolesResponse'
import { useTranslation } from 'react-i18next'
import { RootState } from '../../store/Store'

export const useAddUserRolesHooks = (getRoleList: ApplicationTypesData[]) => {
  const selectedUserRoles = useSelector(
    (state: RootState) => state.userRole.roles,
  )
  const selectedData = useSelector((state: RootState) => state.userRole)
  const [selectedAppCode, setSelectedAppCode] = useState<string>()
  const [appRoles, setAppRoles] = useState<RoleInfoData[]>()
  const [localSelectedData, setLocalSelectedData] = useState<
    appSelectedTypesData[]
  >(selectedUserRoles ?? [])
  const { t } = useTranslation(['translation'])
  const applicationTypes = useSelector<RootState, ApplicationTypes | undefined>(
    (state: RootState) => state.userRole.applicationTypes,
  )
  const dispatch = useDispatch()

  const handleAppSelection = (appValue: string) => {
    setSelectedAppCode(appValue)
  }
  useEffect(() => {
    if (getRoleList?.length > 0) {
      setSelectedAppCode(getRoleList[0].applicationCode)
      setAppRoles(getRoleList[0].roles)
    }
  }, [getRoleList])
  useEffect(() => {
    const getAppRoles = getRoleList?.filter(
      (item: ApplicationTypesData) => item?.applicationCode === selectedAppCode,
    )
    if (getAppRoles?.length > 0) {
      setAppRoles(getAppRoles[0].roles)
    }
  }, [selectedAppCode])

  const handleRoleSelection = (value: string) => {
    let totalSelectedList = [...(localSelectedData ?? [])]
    const checkAppExists = totalSelectedList?.some(
      (role: appSelectedTypesData) =>
        role?.applicationCode === selectedAppCode && role?.roleCode !== value,
    )
    if (checkAppExists) {
      const updatedRoles = totalSelectedList?.map(
        (role: appSelectedTypesData) => {
          if (role.applicationCode === selectedAppCode) {
            return { ...role, roleCode: value }
          }
          return role
        },
      )
      totalSelectedList = updatedRoles ?? []
    } else {
      totalSelectedList.push({
        applicationCode: selectedAppCode as string,
        roleCode: value,
      })
    }
    setLocalSelectedData(totalSelectedList)
    dispatch(
      addUserData({
        data: totalSelectedList,
        type: USER_ACTION.ADD_USER_ROLES,
      }),
    )
  }

  const removeSelectedRole = (code: string) => {
    if (code === applicationTypes?.[APP_TYPE.CUSTOMER_APP]) {
      dispatch(
        addUserData({
          type: USER_ACTION.REMOVE_CUSTOMER_SELECTION,
        }),
      )
    }
    const filteredRoles = (localSelectedData ?? [])?.filter(
      (role: appSelectedTypesData) => {
        return role.applicationCode !== code
      },
    )
    setLocalSelectedData(filteredRoles)
    dispatch(
      addUserData({
        data: filteredRoles,
        type: USER_ACTION.ADD_USER_ROLES,
      }),
    )
  }

  const checkedRoles = (app: ApplicationTypesData) => {
    const roleCode = (localSelectedData ?? [])?.find(
      (role: appSelectedTypesData) =>
        role.applicationCode === app.applicationCode,
    )?.roleCode
    return app.roles?.find((role: RoleInfoData) => role.roleCode === roleCode)
      ?.roleName
  }
  const isCustomerSelected = () => {
    return (localSelectedData ?? []).some(
      (role: appSelectedTypesData) =>
        role.applicationCode === applicationTypes?.[APP_TYPE.CUSTOMER_APP],
    )
  }

  return {
    selectedData,
    selectedAppCode,
    appRoles,
    handleAppSelection,
    handleRoleSelection,
    checkedRoles,
    removeSelectedRole,
    isCustomerSelected,
    localSelectedData,
    t,
  }
}
